export function isNumeric(str: string) {
  // we only process strings!
  return (
    !isNaN(Number.parseInt(str, 10)) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(Number.parseFloat(str))
  ); // ...and ensure strings of whitespace fail
}
